module.exports = __webpack_public_path__ + "static/media/pg_dnm_intertidal_zone.5d933b9c.jpg";